import React from "react";
import styles from "../specialities.module.css";
import SpecialitiesBanner from "../../../components/Banners/Speacialities-Banner/speacialities-banner";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import SpecialityFeatures from "../../../components/SpecialityFeatures/specialityFeatures";
import TextOnly from "../../../components/TextOnly/textOnly";
import MetaTags from "../../../components/MetaTags";
const MultivendorSolution = () => {
  const bannerContent = {
    heading: "Multivendor E-commerce Solutions",
    subText: (
      <>
       At Ninjas Code, we specialize in building scalable Multivendor E-commerce Solutions that cater to diverse industries. Whether you’re launching a food delivery app, a marketplace for goods, or a service-based platform, we have the expertise to build anything you need.
      </>
    ),
  };

  const specialityAbout = [
    {
      aboutImage: {
        url: "assets//Speciality-Images/Streamlined-Vendor-Onboarding.webp",
        alt: "Streamlined Vendor Onboarding",
      },
      aboutTitle: { title: `Streamlined Vendor Onboarding`, highlightedTitle: "" },
      aboutDescription: (
        <>
Simplify the vendor registration process with intuitive forms and step-by-step onboarding flows, ensuring a seamless start for new sellers.
        </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Centralized-Vendor-Management.webp",
        alt: "Centralized Vendor Management",
      },
      aboutTitle: { title: `Centralized Vendor Management`, highlightedTitle: "" },
      aboutDescription: (
        <>
Monitor and manage vendor performance, inventory, and order statuses from a single, easy-to-use admin dashboard.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Customizable-Storefronts.webp",
        alt: "Customizable Storefronts",
      },
      aboutTitle: { title: `Customizable Storefronts`, highlightedTitle: "" },
      aboutDescription: (
        <>
Empower vendors to personalize their stores with branding, product catalogs, and promotions tailored to their audience. </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Integrated-Payment-Gateways.webp",
        alt: "Integrated Payment Gateways",
      },
      aboutTitle: { title: `Integrated Payment Gateways`, highlightedTitle: "" },
      aboutDescription: (
        <>
Offer secure, flexible payment options for vendors and customers, supporting payouts and commission tracking.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Real-Time-Analytics.webp",
        alt: "Real-Time Analytics",
      },
      aboutTitle: { title: `Real-Time Analytics`, highlightedTitle: "" },
      aboutDescription: (
        <>
Gain actionable insights into sales, customer behavior, and vendor performance to make informed business decisions.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Built-for-Scalability.webp",
        alt: "Built for Scalability",
      },
      aboutTitle: { title: `Built for Scalability`, highlightedTitle: "" },
      aboutDescription: (
        <>
Expand your marketplace effortlessly as you onboard more vendors and attract a larger customer base. </>
      ),
      flexReverse: "true",
    },
  ];

  const featurePoints = [
    <>Vendor and admin dashboards with role-based access</>,
    <>Multi-language and multi-currency support</>,
    <>Custom commission structures and revenue sharing</>,
    <>Advanced search and filtering for enhanced user experience</>,
    <>Notifications and updates for orders, reviews, and payments</>
  ];

  const finalThoughts = [
    {heading: `Build Your Marketplace Today`},
    {subText: `With Ninjas Code’s Multivendor E-commerce Solution, you can create a thriving platform that connects vendors and customers effortlessly. Get in touch with us to explore how we can customize our solutions for your business needs!`},
  ]

  return (
    <div>
       <MetaTags
     title="Custom Multivendor E-commerce Solutions for Your Marketplace"
     description="Launch your marketplace with Ninjas Code scalable multivendor e-commerce solutions. From vendor management to real-time analytics, get all under one roof."
     />
      <SpecialitiesBanner content={bannerContent} />

      <div className={styles.specialitiesAbout}>
        <div className={styles.container}>
          <h2>Our Multivendor Ecommerce Solutions Include:</h2>
          <ImageWithText aboutContent={specialityAbout} />
        </div>
      </div>

      <SpecialityFeatures features={featurePoints} />

      <TextOnly 
      content={finalThoughts}
      width
      />
    </div>
  );
};

export default MultivendorSolution;
